import React from "react";
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';
import "./LoadingSpinner.scss";

export default withTranslation()(function LoadingSpinner({ t, i18n }) {
  return (
    <div className="spinner-container">
      <div className="loading-spinner">
      </div>
    </div>
  )
})